"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
function validate(schema, value) {
    if (process.env.NODE_ENV === 'production') {
        var parsed = schema.safeParse(value);
        if (!parsed.success) {
            __1.logger.error(parsed.error, value);
        }
    }
    try {
        schema.parse(value);
    }
    catch (err) {
        __1.logger.error(err, value);
        throw err;
    }
}
exports.default = validate;
//# sourceMappingURL=validate.js.map